'use client';

import { useCallback, useState } from 'react';

import { initialFilterState } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter.consts';
import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { useSearchFilter } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-search-filters.hook';

interface UseFiltersDraftReturn {
  draft: FilterState;
  setDraft: (next: Partial<FilterState>) => void;
  reset: () => void;
  apply: () => void;
}

export function useFiltersDraft(): UseFiltersDraftReturn {
  const { filters, setFilters } = useSearchFilter();
  const [draft, setDraftState] = useState<FilterState>(filters);

  const setDraft = useCallback((next: Partial<FilterState>) => {
    setDraftState((prev) => ({ ...prev, ...next }));
  }, []);

  const reset = useCallback(() => {
    setDraftState((previous) => ({ ...initialFilterState, orderBy: previous.orderBy }));
  }, []);

  const apply = useCallback(() => {
    setFilters(draft);
  }, [draft, setFilters]);

  return { draft, setDraft, reset, apply };
}
